import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";

function CartAutobill({ currency, total, setAutoBill }) {
  const { fetchOnlyData } = CashierApi();

  const { data } = useQuery({
    queryKey: ["autobill"],
    queryFn: () => fetchOnlyData(`orders/auto-bill`),
    keepPreviousData: true, // Corrected spelling
  });

  const billName = data?.data[0]?.bill_option?.name;
  // console.log(data?.data[0]?.name);
  useEffect(() => {
    // if (!data?.data) return;

    // console.log(total, parseFloat(data?.data[0]?.percentage));
    let autobill = data?.data?.map((bill) => ({
      bill_name: bill?.name,
      auto_bill:
        bill?.bill_option?.name === "Auto Billing"
          ? Number(bill?.percentage).toFixed(2)
          : ((parseFloat(bill?.percentage) / 100) * parseFloat(total)).toFixed(
              2
            ),
    }));

    setAutoBill(autobill);
  }, [data, total]);

  return (
    <>
      {data?.data?.map((autoBill, index) => (
        <tr
          key={index}
          className="hover:bg-gray-950 border-b border-gray-300 h-4"
        >
          <td className="py-2 px-1 text-center text-wrap">{null}</td>
          <td className="py-2 px-2 text-center text-wrap">{autoBill?.name}</td>
          <td className="py-2 px-2 text-center text-wrap">
            {total
              ? autoBill?.bill_option?.name === "Auto Billing"
                ? `${currency}${autoBill?.percentage}`
                : `${currency}${(
                    (Number(autoBill?.percentage) / 100) *
                    total
                  ).toFixed(2)}`
              : "0.00"}
          </td>
        </tr>
      ))}
    </>
  );
}

export default CartAutobill;
